// src/components/LanguageSelection.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LanguageSelection.css';

function LanguageSelection() {
  const navigate = useNavigate();

  const handleLanguageSelect = (lang) => {
    // 清除localStorage中可能存在的旧的公司相关参数，确保新测评不受影响
    const existingUserInfo = localStorage.getItem('userInfo');
    if (existingUserInfo) {
      const userInfo = JSON.parse(existingUserInfo);
      delete userInfo.companyCode;
      delete userInfo.Job_NID;
      delete userInfo.codeType;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
    
    // 选择语言后传递参数
    navigate(`/interview?defaultLang=${lang}`);
  };

  return (
    <div className="language-selection">
      <h1>请选择语言 / Chọn ngôn ngữ / Select Language</h1>
      <div className="buttons">
        <button onClick={() => handleLanguageSelect('zh-TW')}>中文繁體</button>
        <button onClick={() => handleLanguageSelect('zh-CN')}>中文简体</button>
        <button onClick={() => handleLanguageSelect('vi')}>Tiếng Việt</button>
        <button onClick={() => handleLanguageSelect('en')}>English</button>
      </div>
    </div>
  );
}

export default LanguageSelection;
